import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import api from "../../api";

export default function FearGreedGauge() {
  const [classification, setClassification] = useState("");
  const [value, setValue] = useState("");
  const [loader, setLoader] = useState(false);

  const getFearGreed = async () => {
    try {
      setLoader(true);
      const resp = await api.getCMCFearGreed();
      console.log(resp);
      if (resp?.value) {
        setValue(resp?.value);
        setClassification(resp?.classification);
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getFearGreed();
  }, []);

  const data = [
    { name: "Extreme Fear", value: 20 },
    { name: "Fear", value: 20 },
    { name: "Neutral", value: 20 },
    { name: "Greed", value: 20 },
    { name: "Extreme Greed", value: 20 },
  ];

  const COLORS = ["#ef4444", "#f97316", "#eab308", "#22c55e", "#14b8a6"];

  const RADIAN = Math.PI / 180;
  const cx = 145; // center X
  const cy = 140; // center Y
  const iR = 90;
  const oR = 120;
  const needleValue = value;
  const angle = 180 * (needleValue / 100); // map 0–100 to 0–180°
  const length = (iR + oR) / 2;
  const x = cx + length * Math.cos((180 - angle) * RADIAN);
  const y = cy - length * Math.sin((180 - angle) * RADIAN);

  const Needle = ({ cx, cy, x, y }) => (
    <>
      <circle cx={cx} cy={cy} r={6} fill="#000" stroke="none" />
      <line
        x1={cx}
        y1={cy}
        x2={x}
        y2={y}
        stroke="#000"
        strokeWidth={3}
        strokeLinecap="round"
      />
    </>
  );

  return (
    <div
      style={{ width: 300, height: 200, position: "relative" }}
      className="cmcfearGreedChart mx-auto"
    >
      <ResponsiveContainer>
        <PieChart>
          <Pie
            dataKey="value"
            startAngle={180}
            endAngle={0}
            data={data}
            cx={cx}
            cy={cy}
            innerRadius={iR}
            outerRadius={oR}
            stroke="none"
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <Needle cx={cx} cy={cy} x={x} y={y} />
        </PieChart>
      </ResponsiveContainer>

      {/* Value + Label */}
      <div className="meterNumber">
        <h2 style={{ fontSize: "2rem", margin: 0 }}>{value}</h2>
        <p style={{ margin: 0 }}>{classification}</p>
      </div>
    </div>
  );
}
